import { render } from "./TeamAbout.vue?vue&type=template&id=0f6c8a1f"
import script from "./TeamAbout.vue?vue&type=script&lang=js"
export * from "./TeamAbout.vue?vue&type=script&lang=js"

import "./TeamAbout.vue?vue&type=style&index=0&id=0f6c8a1f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__